import script from "./BookingMenuCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingMenuCategory.vue?vue&type=script&setup=true&lang=ts"

import "./BookingMenuCategory.vue?vue&type=style&index=0&id=45766725&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45766725"]])

export default __exports__